export default {
  primary: '#4caf50',
  secondary: '#4caf50',
  tertiary: '#495057',
  accent: '#82B1FF',
  error: '#f55a4e',
  info: '#00d3ee',
  success: '#5cb860',
  warning: '#ffa21a',
  pipefishGreen: '#679F93',
  pipefishOrange: '#E06B2B',
  pipefishLightBlue: '#A0dCFA',
  pipefishDarkBlue: '#4DB4DB',
  pipefishBlack: '#393A37',
  activeColor: '#3EB4E0',
  blueBackground: '#1E618A'
}
